<template>
  <b-nav-item-dropdown
    v-if="canView"
    class="dropdown-notification mr-25"
    menu-class="dropdown-menu-media"
    right
    @show="refresh"
  >
    <template #button-content>
      <feather-icon
        :badge="gameReminders.count"
        badge-classes="bg-danger"
        class="text-body"
        icon="BellIcon"
        size="21"
      />
    </template>

    <!-- Шапка -->
    <li class="dropdown-menu-header">
      <div class="dropdown-header d-flex">
        <h4 class="notification-title mb-0 mr-auto">
          Напоминалки об играх
        </h4>
        <b-badge
          v-if="gameReminders.count"
          pill
          variant="light-primary"
        >
          {{ gameReminders.count }}
        </b-badge>
      </div>
    </li>

    <!-- Список -->
    <vue-perfect-scrollbar
      :settings="perfectScrollbarSettings"
      class="scrollable-container media-list scroll-area"
      tagname="li"
    >
      <div
        v-if="gameReminders.items.length === 0"
        class="p-1 text-center text-muted"
      >
        Нет актуальных напоминалок
      </div>

      <div
        v-for="item in gameReminders.items"
        :key="item.task_id"
        class="media d-flex align-items-center"
      >
        <div class="media-body">
          <p class="media-heading mb-0">
            <span class="font-weight-bolder">
              {{ formatDateTime(item.start_datetime) }}
            </span>
          </p>
          <b-link
            :href="item.task_url"
            target="_blank"
            class="notification-text"
          >
            {{ item.name }}
          </b-link>
          <div class="notification-text">
            {{ item.count }} / 4
          </div>
        </div>
        <b-button
          variant="warning"
          size="sm"
          class="ml-1 flex-shrink-0"
          :disabled="revivingId === item.task_id"
          @click.stop="revive(item)"
        >
          <b-spinner
            v-if="revivingId === item.task_id"
            small
          />
          <feather-icon
            v-else
            icon="ZapIcon"
            class="mr-50"
          />
          Оживить
        </b-button>
      </div>
    </vue-perfect-scrollbar>

    <!-- Полная таблица со всеми полями осталась на своей странице -->
    <li class="dropdown-menu-footer">
      <b-button
        variant="primary"
        block
        :to="{ name: 'game-reminders' }"
      >
        Все напоминалки
      </b-button>
    </li>
  </b-nav-item-dropdown>
</template>

<script>
import {
  BNavItemDropdown,
  BBadge,
  BLink,
  BButton,
  BSpinner,
} from 'bootstrap-vue'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import { ref, onUnmounted, getCurrentInstance } from '@vue/composition-api'
import axios from '@axios'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { gameReminders, refreshGameReminders } from '@/views/game/gameRemindersBadge'

const REFRESH_INTERVAL_MS = 5 * 60 * 1000

export default {
  components: {
    BNavItemDropdown,
    BBadge,
    BLink,
    BButton,
    BSpinner,
    VuePerfectScrollbar,
  },
  setup() {
    const toast = useToast()
    const revivingId = ref(null)

    // Стор-модуль app-games не регистрируем: навбар живёт постоянно, и его
    // регистрация/дерегистрация конфликтовала бы со страницами игр.
    const canView = getCurrentInstance().proxy.$can('view', 'games')

    const perfectScrollbarSettings = {
      maxScrollbarLength: 60,
      wheelPropagation: false,
    }

    const showToast = (title, variant) => {
      toast({
        component: ToastificationContent,
        props: {
          title,
          icon: variant === 'danger' ? 'AlertTriangleIcon' : 'CheckCircleIcon',
          variant,
        },
      })
    }

    const formatDateTime = iso => new Date(iso).toLocaleString('ru-RU', {
      timeZone: 'Europe/Moscow',
      weekday: 'short',
      day: '2-digit',
      month: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
    })

    const revive = item => {
      revivingId.value = item.task_id
      axios
          .post(`/game-reminders/${item.task_id}/revive`)
          .then(response => {
            showToast(response.data.message || 'Напоминалка обновлена', 'success')
            return refreshGameReminders()
          })
          .catch(error => {
            const message = (error.response && error.response.data && error.response.data.message)
                || 'Ошибка оживления'
            showToast(message, 'danger')
          })
          .finally(() => {
            revivingId.value = null
          })
    }

    // Фоновое обновление держим в самом дропдауне: он есть в навбаре обоих
    // лэйаутов, иначе для горизонтального пришлось бы дублировать таймер.
    let intervalId = null
    if (canView) {
      refreshGameReminders()
      intervalId = setInterval(refreshGameReminders, REFRESH_INTERVAL_MS)
    }
    onUnmounted(() => clearInterval(intervalId))

    return {
      canView,
      gameReminders,
      revivingId,
      perfectScrollbarSettings,
      formatDateTime,
      revive,
      refresh: refreshGameReminders,
    }
  },
}
</script>
